<template><!-- svgo-optimised -->
<svg class="icon icon__minus" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg"><path d="M20.363 11.5v1.25h-16V11.5z"/></svg>
</template>